<template>
  <v-container>
    <v-form ref="form" lazy-validation @submit.prevent v-model="valid">
      <v-row>
        <v-col cols="4">
          <v-select
            label="Carga"
            outlined
            hide-details
            v-model="carga"
            :items="cargas"
            :rules="rules"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-dialog
            ref="fecha_inicio"
            v-model="modals.fecha_inicio"
            :return-value.sync="fecha_inicio"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fecha_inicio"
                label="Fecha inicio"
                outlined
                readonly
                hide-details
                :rules="rules"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="fecha_inicio" scrollable :max="fecha_fin">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modals.fecha_inicio = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.fecha_inicio.save(fecha_inicio)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="4">
          <v-dialog
            ref="fecha_fin"
            v-model="modals.fecha_fin"
            :return-value.sync="fecha_fin"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fecha_fin"
                label="Fecha fin"
                outlined
                readonly
                hide-details
                :rules="rules"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="fecha_fin" scrollable :min="fecha_inicio" :max="today">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modals.fecha_fin = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.fecha_fin.save(fecha_fin)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col class="d-flex justify-end">
          <v-btn
            color="primary"
            class="mx-1"
            @click.stop="recalcularHorarios"
            :loading="loading"
            :disabled="!valid"
          >Recalcular Horarios</v-btn>
          <v-btn
            color="primary"
            class="mx-1"
            @click.stop="recalcularData"
            :loading="loading"
            :disabled="!valid"
          >Recalcular Data</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { apiv1 } from "../../../../libs/apiv1";
import { Auth } from "../../../../classes/Auth";
import { apiPython } from "../../../../libs/api.python";

const auth = new Auth();

const today = moment().format("YYYY-MM-DD");

export default Vue.extend({
  name: "Fixer",
  data: () => ({
    cargas: [],
    loading: false,
    today: today,
    rules: [v => !!v || "Campo obligatorio"],
    valid: true,
    carga: null,
    fecha_inicio: null,
    fecha_fin: null,
    mode: null,
    modals: {}
  }),
  mounted() {
    this.getCargas();
  },
  methods: {
    getCargas: function() {
      apiv1
        .get(`cargas?project=${auth.getProject().id}`)
        .then(res => (this.cargas = res.data));
    },
    recalcularHorarios: function() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        apiPython({
          url: "recalcular-horarios",
          method: "PUT",
          data: {
            carga: this.carga,
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin
          }
        }).then(res => {
          this.loading = false;
          this.carga = null;
          this.$awn.success(res.data.msg);
        });
      }
    },
    recalcularData: function() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        apiPython({
          url: "recalcular-data",
          method: "PUT",
          data: {
            carga: this.carga,
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin
          }
        }).then(res => {
          this.loading = false;
          this.carga = null;
          this.$awn.success(res.data.msg);
        });
      }
    }
  }
});
</script>

<style>
</style>